import React from 'react';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import CompatibleLoaders from './components/compatibleLoaders';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import {
  descriptionKeyModelCompatibleLoaders,
  descriptionKeySeriesCompatibleLoaders,
  eyebrowKeyModelCompatibleLoaders,
  eyebrowKeySeriesCompatibleLoaders,
  titleKeyModelCompatibleLoaders,
  titleKeySeriesCompatibleLoaders,
} from '../../constants/dictionary.constants';

const ProductCompatibleLoaderListing = (props) => {
  const apiResponse = isEmptyResponse(props) && props?.fields?.apiData?.items?.length > 0;
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }
  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  const getDictionaryKey = (seriesLoadersListingKey, modelLoadersListingKey) => {
    if (props?.isModelLoders) {
      return modelLoadersListingKey;
    }
    return seriesLoadersListingKey;
  };

  return (
    <CompatibleLoaders
      seeMoreKey={'cnhi-seeMoreLoaders'}
      seeLessKey={'cnhi-seeLessLoaders'}
      {...props}
      id={props?.rendering?.componentName}
      eyebrowKeyCompatibleLoaders={getDictionaryKey(eyebrowKeySeriesCompatibleLoaders, eyebrowKeyModelCompatibleLoaders)}
      titleKeyCompatibleLoaders={getDictionaryKey(titleKeySeriesCompatibleLoaders, titleKeyModelCompatibleLoaders)}
      descriptionKeyCompatibleLoaders={getDictionaryKey(descriptionKeySeriesCompatibleLoaders, descriptionKeyModelCompatibleLoaders)}
    />
  );
};

export default ProductCompatibleLoaderListing;
